import styled from 'styled-components';

import { TipBoxPreset } from '@xing-com/tip-box';

const Tooltip = styled(TipBoxPreset)`
  margin-top: -10px;
  max-width: 290px;
  min-width: 290px;

  & button:focus-visible {
    outline: none;
  }
`;

export { Tooltip };
